// Parses a formatted currency string (e.g. "$0.00" or "€1.234,56") into a number.
// Returns 0 when the value is missing or has no numeric content, so callers can
// compare against 0 without depending on a specific currency format.
export default function parseCurrencyDisplay(display?: string | null): number {
    if (!display) {
        return 0;
    }
    const cleaned = display.replace(/[^0-9.-]/g, "");
    const value = parseFloat(cleaned);
    return Number.isFinite(value) ? value : 0;
}
